import { formatCurrency } from "../../../../../utils/utils";
import { createQuestionValueMap, findValue, getUpdatedItems, mapToTupleArray, PageJson } from "../../../../common/summary-common/applicationSummary";
import { ConfirmationData, updateMapWithFields } from "../../../../common/summary-common/confirmationData";



export const defaultFinancialInformation: Map<string, ConfirmationData> = new Map([
    ["f48b43bd-44f4-44ba-ba34-99f1f2bfa62a", { fontWeight: "bold", }],
    ["1d5e1d67-baa9-4733-aa32-0d70548f189e", {}],
    ["f1cf8f70-cbf6-4fcc-a087-a0316c08a725", {}],
    ["a8afa725-5d58-45be-945a-e79924e7497d", {}],
    ["9287d629-98ca-49fe-af4b-1c162cb6982c", {}],
    ["48565545-5243-43ab-ab0d-1332a38da0ca", {}],
    ["f48b43bd-44f4-44ba-ba34-99f1f2bfa62a|dda0e8b2-057c-4a3e-9c19-b9a57bc667ad", {}],
    ["sumaActivos", { label: "Total Activos", showBorder: true }],

    ["9a8ca5e1-7661-436e-9de1-d32434928605", { fontWeight: "bold", }],
    ["194cddc1-09d5-4505-807f-96efdabc4d89", {}],
    ["8ff72009-ab23-43aa-84c5-0e4dd4834174", {}],
    ["9a8ca5e1-7661-436e-9de1-d32434928605|dda0e8b2-057c-4a3e-9c19-b9a57bc667ad", {}],
    ["sumaPasivos", { label: "Total Pasivos", showBorder: true }],
    ["balance", { label: "Balance Activos/Pasivos", fontWeight: "bold", showBorder: true }],
    ["c390ac19-52fa-4ac0-8163-5b7032dff3fa", { fontWeight: "bold", }],
    ["ff1d86d7-e5b0-4e40-ac24-7327d6c1404f", { label: `Ingreso Anual (${new Date().getFullYear()})`, }],
    ["556bfe93-17ee-453b-bb3f-fcb706251fec", { label: `Ingreso Anual (${new Date().getFullYear() - 1})`, showBorder: true }],
    ["4d541b02-d588-4a41-8348-73f8a497fc92", { fontWeight: "bold", }],
    ["45164ce8-b0cb-4310-a3ea-e0f141536e1c", { label: "Sí/No", showBorder: true }],

]);

const defaultCompaniesGroups: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Compañía", fontWeight: "bold", }],
    ["3b5d755a-0de8-4cdc-b58f-5fc789f527a0", {}],
    ["3cb46b20-c80d-48b4-8e7d-5c2f374c4b59", {}],
    ["b85044f9-adb5-46a4-a928-ccf87d194c85", { showBorder: true }],
]);

export const updateFinancialInformation = (page: PageJson | undefined, cd: Map<string, ConfirmationData>): Map<string, ConfirmationData> => {
    if (page === undefined) {
        return new Map();
    }
    console.log(page);
    const answersMap = createQuestionValueMap(page);

    // Obtener valores de activos y calcular suma
    const activos = [
        findValue(page, "2506fba5-1f33-4098-af4b-3ce30465ea63", "f48b43bd-44f4-44ba-ba34-99f1f2bfa62a", "1d5e1d67-baa9-4733-aa32-0d70548f189e"),
        findValue(page, "2506fba5-1f33-4098-af4b-3ce30465ea63", "f48b43bd-44f4-44ba-ba34-99f1f2bfa62a", "f1cf8f70-cbf6-4fcc-a087-a0316c08a725"),
        findValue(page, "2506fba5-1f33-4098-af4b-3ce30465ea63", "f48b43bd-44f4-44ba-ba34-99f1f2bfa62a", "a8afa725-5d58-45be-945a-e79924e7497d"),
        findValue(page, "2506fba5-1f33-4098-af4b-3ce30465ea63", "f48b43bd-44f4-44ba-ba34-99f1f2bfa62a", "9287d629-98ca-49fe-af4b-1c162cb6982c"),
        findValue(page, "2506fba5-1f33-4098-af4b-3ce30465ea63", "f48b43bd-44f4-44ba-ba34-99f1f2bfa62a", "48565545-5243-43ab-ab0d-1332a38da0ca"),
        findValue(page, "2506fba5-1f33-4098-af4b-3ce30465ea63", "f48b43bd-44f4-44ba-ba34-99f1f2bfa62a", "dda0e8b2-057c-4a3e-9c19-b9a57bc667ad")
    ];

    const sumaActivos = activos
        .map(val => parseFloat(val) || 0)
        .reduce((sum, val) => sum + val, 0);

    // Agregar suma al answersMap
    answersMap.set("sumaActivos", { value: formatCurrency(sumaActivos), hidden: false });

    // Obtener valores de pasivos y calcular suma
    const pasivos = [
        findValue(page, "2506fba5-1f33-4098-af4b-3ce30465ea63", "9a8ca5e1-7661-436e-9de1-d32434928605", "194cddc1-09d5-4505-807f-96efdabc4d89"),
        findValue(page, "2506fba5-1f33-4098-af4b-3ce30465ea63", "9a8ca5e1-7661-436e-9de1-d32434928605", "8ff72009-ab23-43aa-84c5-0e4dd4834174"),
        findValue(page, "2506fba5-1f33-4098-af4b-3ce30465ea63", "9a8ca5e1-7661-436e-9de1-d32434928605", "dda0e8b2-057c-4a3e-9c19-b9a57bc667ad")
    ];

    const sumaPasivos = pasivos
        .map(val => parseFloat(val) || 0)
        .reduce((sum, val) => sum + val, 0);

    // Agregar suma al answersMap
    answersMap.set("sumaPasivos", { value: formatCurrency(sumaPasivos), hidden: false });

    // Calcular y agregar balance
    const balance = sumaActivos - sumaPasivos;
    answersMap.set("balance", { value: formatCurrency(balance), hidden: false });

    const updatedCompanyItems = getUpdatedItems(page, "e040b8a3-96f9-4bf3-8865-5d2915935e25", "258dc8e3-3638-446f-ba1b-5a804264526f", defaultCompaniesGroups, false);

    if (answersMap.get("45164ce8-b0cb-4310-a3ea-e0f141536e1c")?.value === "Sí") {
        cd = new Map([
            ...cd,
            ...updatedCompanyItems,
        ])
    }
    return updateMapWithFields(mapToTupleArray(answersMap), cd);
}